<template>
    <v-container fluid class="pa-0">
    <v-select :items="typeListByGroup['QIZ']" item-text="typ_name" item-value="typ_id" outlined dense
        v-model="qizTypId" label="Type de champ" >
    </v-select>
    <v-treeview 
            :items="itemsTree"
            :search="search"
            item-text="qiz_name" item-key="qiz_id"
            hoverable activatable open-on-click> <!-- :filter="filter" :open.sync="treeViewopen"  -->
            <template v-slot:prepend="{ item }">
            <v-icon v-if="item.children">
                {{  typeListById[item.qiz_typ_id_field].typ_icon }}
            </v-icon>
            </template>
            <template v-slot:label="{ item }">{{item.qiz_name}} {{ (item.qiz_description) ? '(' + item.qiz_description + ')' : '' }}</template>
            <template v-slot:append="{ item }">
                <v-chip v-show="(item.qiz_value)" class="ma-1" label color="secondary">{{ item.qiz_value }}</v-chip>
                <v-btn depressed class="ml-2 rounded-xl" color="amber darken-1" :to="{ name: 'quizzes-edit', params: { qiz_id: item.qiz_id } }">
                    <v-icon left class="mr-2">mdi-pencil</v-icon>Editer
                </v-btn>
            </template>
    </v-treeview>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'

export default {
    name: 'quizzes-list',
    computed: {
        ...mapState(useQuizStore, {itemList: 'itemList' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            qizTypId: 'QIZ01',
            headers: [
                { text: 'Nom',    value: 'qiz_name', align: 'left'},
                { text: 'Type',   value: 'qiz_typ_id', align: 'left'},
                { text: 'Action', value: 'qiz_id', align: 'right'},
            ],
            itemsTree: [],
        }
    },
    async mounted () {
        await this.fetchItems('?per_page=false')
        this.itemsTree = this.list_to_tree(this.itemList)
    },
    methods: {
        ...mapActions(useQuizStore, {fetchItems: 'fetchItems'}),
        list_to_tree(list) {
            var map = {}, node, roots = [], i;
            
            for (i = 0; i < list.length; i += 1) {
                map[list[i].qiz_id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }
            
            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.qiz_id_parent) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.qiz_id_parent]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        }
    },
}
</script>